// extracted by mini-css-extract-plugin
export default {"name":"Header_name__xvP4V","code":"Header_code__8Xd7H","item":"Header_item__Wmalf"};